var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Protocol } from './protocol';
import { RequestMethod } from '@angular/http';
var LongPollingProtocol = (function (_super) {
    __extends(LongPollingProtocol, _super);
    function LongPollingProtocol(url, loggerService, coreWebService, queryBuilder) {
        var _this = _super.call(this, loggerService) || this;
        _this.url = url;
        _this.coreWebService = coreWebService;
        _this.queryBuilder = queryBuilder;
        _this.isClosed = false;
        if (!queryBuilder) {
            _this.queryBuilder = function (data) { return null; };
        }
        return _this;
    }
    LongPollingProtocol.prototype.start = function (queryParameters) {
        var _this = this;
        this.isClosed = false;
        this.loggerService.info('Starting long polling connection');
        this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.url.getUrlWith(queryParameters)
        })
            .pluck('entity')
            .subscribe(function (data) {
            _this.loggerService.debug('new Events', data);
            if (data instanceof Array) {
                data.forEach(function (message) {
                    _this._message.next(message);
                });
            }
            else {
                _this._message.next(data);
            }
            if (!_this.isClosed) {
                var query = _this.queryBuilder(data);
                _this.start(query);
            }
        }, function () {
            _this.loggerService.info('A error occur connecting through long polling');
            if (!_this.isClosed) {
                _this.start();
            }
        });
    };
    LongPollingProtocol.prototype.destroy = function () {
        this.loggerService.info('destroying long polling');
        this.isClosed = true;
    };
    return LongPollingProtocol;
}(Protocol));
export { LongPollingProtocol };
//# sourceMappingURL=long-polling-protocol.js.map